// extracted by mini-css-extract-plugin
module.exports = {"overflow":"T6z1h","summary":"qFSl7","item":"XskX4","value":"ahVRd","label":"U9qC4","loader":"_5+wso"};